import { Component, OnInit } from '@angular/core'

@Component({
  selector: 'kit-general-2',
  templateUrl: './2.component.html',
})
export class CuiGeneral2Component implements OnInit {
  constructor() {}
  ngOnInit() {}
}
